import { render, staticRenderFns } from "./RedemptionHistory.vue?vue&type=template&id=4e7d0585"
import script from "./RedemptionHistory.vue?vue&type=script&lang=js"
export * from "./RedemptionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports